import { useEffect, useState } from "react";

import Close from "assets/close-small.svg";
import Input from "../Input";
import { IAddress, ISuperficialAddressProps } from "interfaces/Address";
import Maps from "../Map";
import { createAddressService } from "services/AddressServices";
import { IFormError } from "interfaces/ExpressError";
import { fireToast } from "services/sweetAlertConfig";

import * as S from "./styles";
import { InputMap } from "components/InputMap";

type Props = {
  onClose: () => void;
};

export function AddressPopup({ onClose }: Props) {
  const [locale, setLocale] = useState<IAddress>({} as IAddress);
  const [errors, setErrors] = useState<IFormError>({});

  const [name, setName] = useState("");
  const [address, setAddress] = useState<ISuperficialAddressProps>(
    {} as ISuperficialAddressProps
  );
  useEffect(() => {
    setLocale((value) => {
      value.CoordX = CoordX;
      value.CoordY = CoordY;
      value.city = address.city;
      value.district = address.district;
      value.number = address.number;
      value.postalCode = address.postalCode;
      value.street = address.street;
      value.uf = address.uf;
      return value;
    });
  }, [address]);
  const [CoordY, setCoordY] = useState(0);
  const [CoordX, setCoordX] = useState(0);
  return (
    <S.Wrapper>
      <S.Container>
        <S.Header>
          <header>
            <S.Title>Cadastrar Localidade</S.Title>
          </header>

          <S.CloseButton type="button" onClick={() => onClose()}>
            <img src={Close} alt="Botão de fechar o pop-up" />
          </S.CloseButton>
        </S.Header>
        <S.Body>
          <Input
            id="Nome da localidade"
            name="locale_name"
            label="Nome da Localidade"
            required={true}
            type="text"
            onChange={(e) => {
              setName(e.target.value);
            }}
            error={errors?.locale_name}
          />

          <div>
            <label>Endereço</label>

            <InputMap 
              location={{
                lat: CoordX,
                lng: CoordY
              }}
              onCoordsChange={(coords) => {
                setCoordX(coords.lat);
                setCoordY(coords.lng);
              }}
              onAddressChange={(address) => {
                setAddress(address);
              }}
              error={errors?.maps}
            />
          </div>

          <S.WorkingStatus
            onClick={() => {
              createAddressService({ locale, name })
                .then(() => {
                  localStorage.setItem(
                    "message",
                    "Os dados da ocorrência veicular foram salvos corretamente."
                  );
                  window.location.reload();
                })
                .catch(() => {
                  fireToast("Algo deu errado");
                });
            }}
          >
            <p>Cadastrar</p>
          </S.WorkingStatus>
        </S.Body>
      </S.Container>
    </S.Wrapper>
  );
}
